// extracted by mini-css-extract-plugin
export var container = "index-module--container--xHyCj";
export var image = "index-module--image--VXocJ";
export var name = "index-module--name--gmWyk";